export enum OnboardingStep {
    AlreadyOnboarded = 0,
    Introduction = 1,
    Subscription = 2,
    InventoryPrinciple = 3,
    ConfirmInformation = 4,
    ConfirmTransferData = 5,
    TransferDataInProgress = 6,
    IntegrationCompleted = 7,
    Offboarded = 8,
}

export enum RackbeatPlan {
    Basic = 1,
    Premium = 2,
}

export enum RackbeatPrinciple {
    Average = 1,
    Fifo = 2,
}

export interface CreateGrantRequest {
    subscriptionPlan: RackbeatPlan;
    inventoryPrinciple: RackbeatPrinciple;
    currencyCode: string;
    rackbeatIdentificationToken: string;
    consentToNewsletter: boolean;
}

export interface SyncDataItem {
    name: string;
    syncInProgress?: boolean;
    isSynced: boolean;
    viewOrder: number;
    synOrder: number;
    isLast?: boolean;
}

export enum OnboardingStatus {
    Onboarded = 1,
    NotOnboarded = 2,
    Offboarded = 3,
}
